import { styled } from 'styled-components';

import type { Theme } from '../../theme';

import type { IconIntent, IconSize } from './types';

type ThemeProps = {
  theme: Theme;
};
type ContainerProps = {
  color?: string;
  intent?: IconIntent;
  size?: IconSize;
};

const colorByIntent = (theme: Theme): Record<IconIntent, string> => ({
  danger: theme.designTokens.iconIntentDangerColor,
  disabled: theme.designTokens.iconIntentDisabledColor,
  primary: theme.designTokens.iconIntentPrimaryColor,
  success: theme.designTokens.iconIntentSuccessColor,
  warning: theme.designTokens.iconIntentWarningColor,
});

const fontSizeByIconSize = (theme: Theme) => ({
  s: theme.designTokens.iconFontSizeS,
  m: theme.designTokens.iconDefaultFontSize,
  l: theme.designTokens.iconFontSizeL,
  xl: theme.designTokens.iconFontSizeXL,
});

const getIconSize = ({ theme, size }: ContainerProps & ThemeProps) => (size ? fontSizeByIconSize(theme)[size] : '1em');

const Container = styled.i<ContainerProps>`
  color: ${({ intent, theme }) => (intent ? colorByIntent(theme)[intent] : 'inherit')};
  display: inline-block;
  vertical-align: middle;
  line-height: 1;
  font-size: ${getIconSize};
  height: ${getIconSize};
  width: ${getIconSize};
  > svg {
    display: block;
  }
`;

export const Styled = {
  Container,
};
